/* eslint-disable comma-dangle */
/* eslint-disable import/extensions */
import React, { useEffect, useState } from "react";

import { DiscordRoles } from "../../../types/discord_roles";
import { getGuildRoles } from "../../lib/discordQueries";

/**
 * Returns the roles associated to a guild
 *
 * @param guildId - the guild id
 * @returns - { guildRoles: an array of guild objects, setGuildRoles: function to set guild roles, loading: true if done, false if not}
 */
function useGuildRoles(guildId: string) {
  const [guildRoles, setGuildRoles] = useState<DiscordRoles[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  // Load guild roles from Supabase
  const loadGuildRoles = async (): Promise<void> => {
    setLoading(true);
    try {
      const data: DiscordRoles[] | null = await getGuildRoles(guildId);
      if (data) setGuildRoles(data);
      if (!data) setGuildRoles([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadGuildRoles();
  }, [guildId]);

  return { data: guildRoles, setGuildRoles, isLoading: loading };
}

export default useGuildRoles;
